import React from 'react';
import { Button, ButtonGroup } from 'anf-core-react';
import CTAButtons from '../OrderHistory/CTAButtons';
import CancelOrderControls from './CancelOrderControls';
import { TmntHtml, TmntText } from '../Common/Text';
import { ctaGroupButtonsProps, ctaGroupButtonsDefaultProps } from './props';
import ResendOrderConfirmationButton from './ResendOrderConfirmation';
import ShareGiftReceipt from './ShareGiftReceipt';

export default function OrderDetailsCTAGroup({ ctaGroupButtons }) {
  const { ctaGroup, number, resendOrder } = ctaGroupButtons;

  if (!ctaGroup.length) return null;

  // Display Track My Order only when there is a tracking url
  const trackOrderCTA = ctaGroup.find(
    ({ label }) => label?.value === 'Track My Order',
  );

  // Remove Track Order from the list of other CTAs
  const filteredCTAs = ctaGroup.filter(
    ({ label }) => label?.value !== 'Track My Order',
  );

  const renderCTAs = () => filteredCTAs.map(({ label, value }, index) => {
    const key = `${number}_${label?.key || index}`;

    // Display the return by Date Text below Return/Exchange Button
    if (label?.value === 'return-and-exchange-policy') {
      return (
        <div key={key} className="return-and-exchange-policy">
          <TmntHtml tmnt={{ key: label.key, value }} />
        </div>
      );
    }

    // Display resend order confirmation button
    if (label?.key === 'WSS_RESEND_ORDER_CONFIRMATION' || label?.key === 'RESEND_DELIVERY_EMAIL') {
      return (
        <ResendOrderConfirmationButton
          key={key}
          resendOrder={resendOrder}
        />
      );
    }

    // Display resend order confirmation button
    if (label?.key === 'OD_SHARE_GIFT_RECEIPT') {
      return (
        <ShareGiftReceipt
          key={key}
          label={label}
        />
      );
    }

    // Render cancel modal button
    if (value.includes('cancelOrderModal')) {
      const [, , orderNumber, email] = value.split(':');
      return (
        <CancelOrderControls
          email={email}
          key={key}
          label={label}
          orderNumber={orderNumber}
        />
      );
    }

    // Render Return/Exchange button
    if (value.includes('startReturnAndExchanges')) {
      const dre20MfeEvent = new CustomEvent('dre20:start');
      /* Using html button here since it needs to have custom attributes data-returns-flow="RF0"
         for the DRE20 MFE to work correctly.
      */
      return (
        <button
          aria-label={label?.value}
          data-full-width="true"
          data-returns-flow="RF0"
          data-testid="start-return-exchange-mfe"
          className="button returns-view-toggle"
          data-variant="tertiary-light"
          type="button"
          onClick={() => window.dispatchEvent(dre20MfeEvent)}
        >
          <TmntText tmnt={label} />
        </button>
      );
    }

    return (
      <Button key={key} variant="tertiary-light" isFullWidth href={value} target="_blank">
        <TmntHtml tmnt={label} />
      </Button>
    );
  });

  if (trackOrderCTA) {
    return (
      <CTAButtons
        detailsHref={trackOrderCTA.value}
        detailsText={<TmntHtml tmnt={trackOrderCTA.label} />}
        target="_blank"
      >
        {renderCTAs()}
      </CTAButtons>
    );
  }

  return (
    <ButtonGroup variant="vertical-collapsed">
      {renderCTAs()}
    </ButtonGroup>
  );
}

OrderDetailsCTAGroup.propTypes = ctaGroupButtonsProps;
OrderDetailsCTAGroup.defaultProps = ctaGroupButtonsDefaultProps;
